import React from 'react';
import { Star } from 'lucide-react';
const CHECKOUT_URL = 'https://levance.store/products/levance%E2%84%A2-ultrasonic-tick-repelling-device';
export const CTAButton = ({
  children,
  className = '',
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={onClick} className={`inline-flex items-center justify-center bg-accent text-white font-bold tracking-wide uppercase py-4 px-8 rounded-sm hover:bg-opacity-90 transition-all shadow-sm ${className}`} data-id="element-434">
      {children}
    </a>;
};
export const StarRating = ({
  rating = 5,
  className = ''
}: {
  rating?: number;
  className?: string;
}) => {
  return <div className={`flex items-center text-accent ${className}`} data-id="element-435">
      {[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i < Math.floor(rating) ? 'fill-current' : 'fill-transparent'}`} data-id="element-436" />)}
    </div>;
};
export const ImagePlaceholder = ({
  description,
  caption,
  className = '',
  aspectRatio = 'aspect-video'
}: {
  description: string;
  caption?: string;
  className?: string;
  aspectRatio?: string;
}) => {
  return <figure className={`w-full flex flex-col ${className}`} data-id="element-437">
      <div className={`w-full ${aspectRatio} bg-sage/30 border border-sage flex items-center justify-center p-6 text-center rounded-sm`} data-id="element-438">
        <p className="text-foreground/60 text-sm font-medium max-w-md" data-id="element-439">
          {description}
        </p>
      </div>
      {caption && <figcaption className="mt-3 text-sm italic text-foreground/80 text-center px-4" data-id="element-440">
          {caption}
        </figcaption>}
    </figure>;
};
export const SectionWrapper = ({
  children,
  className = '',
  isWide = false
}: {
  children: React.ReactNode;
  className?: string;
  isWide?: boolean;
}) => {
  return <section className={`w-full px-5 py-12 md:py-16 flex justify-center ${className}`} data-id="element-441">
      <div className={`w-full ${isWide ? 'max-w-5xl' : 'max-w-[720px]'}`} data-id="element-442">
        {children}
      </div>
    </section>;
};